
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import toast from "react-hot-toast";
import States from '../../constants/States';
import { useAppConfig } from '../../providers/AppConfigProvider';
import { EventEmitter } from '../../utility/events';
import { isJson } from '../../utility/util';
import "./index.css";
import { getAgentState, getChatContactList } from './socketUtilFn';

export const AppWebSocketComp = ({ agentStatus }) => {
    const [ws, setWs] = useState(null);
    const { wsConn, updateWsConnection, contactsList, selectInitialContact, activeContactList, updateContactList, isAppOnline } = useAppConfig();
    const [messageHistory, setMessageHistory] = useState([]);
    const [messageHistoryMap, setMessageHistoryMap] = useState({});
    const [webSocketStatus, setWebSocketStatus] = useState({
        "status": "close"
    })
    const [userStatus, setUserStatus] = useState([])

    useEffect(() => {
        // If application is onlne and 
        if (isAppOnline && checkWsStatus() === 3) {
            wssConn(3)
        }
        // if (!isAppOnline) {
        //     closeConnection();
        // }
    }, [isAppOnline])

    const checkWsStatus = () => {
        if (ws) {
            return ws.readyState
        }
        return 3;
    }
    const buildWSSURL = () => {
        if (process.env.REACT_APP_PROJECT_STAGE === 'prod') {
            return 'wss://2h7gife5z1.execute-api.us-east-1.amazonaws.com/prod'
        } else {
            return 'wss://9pkz5v1dyi.execute-api.us-east-1.amazonaws.com/qa'
        }
    }
    
    const wssConn = async (i) => {
        try {
            let agentState = await getAgentState();
            if (isAppOnline && agentState && agentState.name === States.agentStateTypes.AVAILABLE) {
                let socketURL = buildWSSURL();
                console.log("socketURL :: process.env.REACT_APP_PROJECT_STAGE", socketURL)
                setWs(new WebSocket(`${socketURL}?initialContactId=initialConn&connType=AGENT`));
            }
        } catch (error) {
            setWs(null)
        }
    }

    function closeConnection(q) {
        console.log("closeConnection called", q)
        if (ws) ws.close();
    };

    // useEffect(() => {
    //     wssConn(0);
    // }, [])

    const addExistingConnections = () => {
        console.log("addExistingConnections callled")
        contactsList.map((contact, i) => {
            if (contact.getType() === window.connect.ContactType.CHAT && contact.isConnected()) {
                let _contactId = contact.getOriginalContactId() ? contact.getOriginalContactId() : contact.getContactId();
                sendWssMessage({
                    "action": "addConnection",
                    "initialContactId": _contactId,
                    "connType": 'AGENT'
                })
                addUserStatus({ "initialContactId": _contactId, "_status": 'Online' });
            }
        })
    }

    useEffect(() => {
        let reduceData = messageHistory.reduce((result, item) => {
            let key = item['initialContactId'];

            if (!key) {
                key = '_general'
            }
            if (!result[key]) {
                result[key] = []
            }
            // result[key].push(item)
            result[key].unshift(item)
            return result
        }, {});
        
        console.log("reduceData : ", reduceData);

        setMessageHistoryMap(reduceData)
    }, [messageHistory])

    const refreshContactList = async () => {
        getChatContactList()
            .then(res => {
                updateContactList(res);
            }).catch(err => {
                updateContactList([]);
            })
    }
    useEffect(() => {
        if (ws) {
            console.log("wssConn status 1", checkWsStatus())
            ws.onopen = () => {
                setWebSocketStatus(prev => ({
                    ...prev, ['status']: 'open'
                }))
                updateWsConnection(ws)
                EventEmitter.subscribe("CONTACT_ACCEPTED", (contact) => {
                    refreshContactList();
                    const originalContactId = contact.getOriginalContactId() ? contact.getOriginalContactId() : contact.getContactId();
                    if (originalContactId && contact.getType() === window.connect.ContactType.CHAT) {
                        ws.send(
                            JSON.stringify({
                                "action": "addConnection",
                                "initialContactId": originalContactId,
                                "connType": "AGENT",
                            }));

                        addUserStatus({ "initialContactId": originalContactId, "_status": 'Online' })
                    }
                });

                EventEmitter.subscribe("CONTACT_REMOVE", (contact) => {
                    refreshContactList();
                    const originalContactId = contact.getContactId();
                    if (originalContactId) {
                        removeUserStatus({ "initialContactId": originalContactId })
                        ws.send(
                            JSON.stringify({
                                "action": "removeConnection",
                                "initialContactId": originalContactId,
                                "connType": "AGENT",
                            }))
                    }
                });

                if (contactsList.length > 0) {
                    addExistingConnections()
                }

            }
            ws.onclose = () => {
                console.log("ws.onclose ")
                setWebSocketStatus(prev => ({
                    ...prev, ['status']: 'close'
                }))

                // Check for Agent status before init the connection
                console.log("navigator.onLine", navigator.onLine);
                console.log("isAppOnline", isAppOnline);
                if (isAppOnline) wssConn(1);
                setTimeout(() => {
                    console.log("isAppOnline 138", isAppOnline);
                }, 1000);

            }
            ws.onmessage = (event) => {
                let tempEvent = isJson(event.data) ? JSON.parse(event.data) : {};
                if (tempEvent.action === "sendEvent") {
                    updateUserStatus(tempEvent)
                } else {
                    setMessageHistory((prev) => prev.concat(isJson(event.data) ? JSON.parse(event.data) : event.data));
                }
            };
        }

        return () => {
            closeConnection(2)
        }
    }, [ws, isAppOnline])

    useEffect(() => {
        if (agentStatus === States.agentStateTypes.AVAILABLE && isAppOnline) {
            wssConn(2);
        } else {
            closeConnection(1);
        }
    }, [agentStatus])

    const sendWssMessage = (msg) => {
        ws.send(JSON.stringify(msg))
    };

    const buildMessageContent = (msg) => {
        switch (msg.action) {
            case 'sendMessage':
                return msg.data;

            case 'sendEvent':
                return msg.data;

            case 'addConnection':
                return 'Connection has added';

            case 'removeConnection':
                return 'Connection has removed';

            case 'connectionEstablished':
                return msg.data;

            case 'connectionEstablished':
                return msg.data;

            default: return msg.action;
        }
    }

    const formatUserDetails = (val) => {
        try {
            let contactDetails = _.find(activeContactList, { 'contactId': val });
            if (contactDetails) {
                return contactDetails.getAttributes().fName.value;
            };
        } catch (error) {
            console.error("formatUserDetails", error)
        }
        return val;
    };

    // userStatus use state Hooks operations
    // 1. Add user status
    const addUserStatus = obj => {
        setUserStatus(current => [...current, obj])
    }

    const updateUserStatus = (req) => {
        setUserStatus(current =>
            current.map(obj => {
                if (obj.initialContactId === req.initialContactId) {
                    return { ...obj, _status: req.data };
                }
                return obj;
            }),
        );
    };

    //  Remove one or more objects from state array
    const removeUserStatus = (req) => {
        toast.success("Connection removed");
        setUserStatus(current =>
            current.filter(obj => {
                return obj.initialContactId !== req.initialContactId;
            }),
        );
    };

    const getUserStatus = (key) => {
        let obj = _.find(userStatus, { initialContactId: key });
        if (obj) {
            return obj._status
        }
    }

    const checkInitialContactIdExist = (key) => {
        let isContactExist = false;
        try {
            for(let _obj of activeContactList){
                if (_obj.getInitialContactId() === key || _obj.getContactId()) {
                    isContactExist =  true;
                    break;
                }
            }
        } catch (error) {
            console.error("checkInitialContactIdExist", error)
        }
        
        return isContactExist;
    }


    return (
        <div className="container-fluid custom-container-wrapper">
            <div className='row user-activity-header'>
                <h4>User Activity</h4>
            </div>
            <div className='row'>
                <div className='col' style={{ "borderBottom": "1px dotted" }}>
                    Connection : {webSocketStatus.status}
                </div>
            </div>
            <div className='row'>
                {
                    Object.entries(messageHistoryMap).map(([key, value], index) => {
                        if (checkInitialContactIdExist(key) || key === '_general') {
                            return (
                                <div key={index} className='col-6 p-3 cust-border-right'>
                                    <div className={`row mb-3 ${selectInitialContact == key ? 'active-contact' : ''}`}>
                                        <div className='col'>
                                            <label>{key === '_general' ? 'COMMON' : `${formatUserDetails(key)}`}</label>
                                        </div>
                                        <div className='col'>
                                            user : <label><b>{`${getUserStatus(key)}`}</b></label>
                                        </div>
                                    </div>
                                    <div className={`row wss-list-group-wrapper`}>
                                        <ul className='list-group'>
                                            {
                                                value.map((message, idx) => (
                                                    <li key={idx} className="list-group-item wss-list-group-item">
                                                        {`${idx} - ${buildMessageContent(message)}`}
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                </div>
                            )
                        }
                    }
                    )
                }
            </div>
        </div>
    );
};

export default AppWebSocketComp